import { useEffect, useState } from "react";
import { DropdownButton, Dropdown } from "react-bootstrap";
import { IOrderData, IStrikeData } from "../../../types";
import "./index.scss";
import { addPosition, getPositions } from "../../../data/db";

interface WatchlistProps {
  dataSource: IStrikeData[];
  UnderlyingName: string;
  expiries: string[];
  lotSize: number;
  fetchData: (expiry: string) => void;
  expiry: string;
  selectedExpiry: (expiry: string) => void;
}

const WatchlistTab = ({
  dataSource,
  UnderlyingName,
  expiries,
  lotSize,
  fetchData,
  expiry,
  selectedExpiry
}: WatchlistProps) => {
  const [quantity, setQuantity] = useState<{
    [key: string]: any;
  }>({});
  const [optionalPrice, setOptionalPrice] = useState<{ [key: string]: number }>(
    {}
  );
  const [positions, setPositions] = useState<{ [key: string]: IOrderData }>({});
  useEffect(() => {
    getPositions(UnderlyingName).then((res: { [key: string]: IOrderData }) =>
      setPositions(res)
    );
  }, []);
  const addItem = (data: any, key: string, isBuy: boolean) => {
    const qty = isBuy ? quantity[key] || 1 : -(quantity[key] || 1);
    const price = optionalPrice[key] || data.lastPrice;
    addPosition({
      symbol: UnderlyingName,
      strike: data.strikePrice,
      expiry,
      price,
      order: isBuy ? "BUY" : "SELL",
      option: data.type,
      qty: qty * lotSize,
      key,
      time: Date.now(),
    }).then(() =>
      getPositions(UnderlyingName).then((res: any) => setPositions(res))
    );
  };
  return (
    <div style={{ textAlign: "center" }}>
      <DropdownButton
        id="dropdown-basic-button"
        title={expiry}
        size="sm"
        variant="success"
      >
        {expiries.map((val, index) => {
          return (
            <Dropdown.Item
              key={index}
              onSelect={() => {
                selectedExpiry(val);
                fetchData(val);
              }}
            >
              {val}
            </Dropdown.Item>
          );
        })}
      </DropdownButton>
      {dataSource &&
        dataSource
          .flatMap((val) => [
            { ...val.CE, type: "Call" },
            { ...val.PE, type: "Put" },
          ])
          .filter(
            (val) => val !== undefined && val.totalTradedVolume !== undefined && val.strikePrice
          )
          .sort((a, b) => b!.totalTradedVolume! - a!.totalTradedVolume!)
          .map((data) => {
            const key =
              UnderlyingName + data.strikePrice + data.type + data.expiryDate;
            return (
              <div
                key={key}
                className={`e-watch-list-card ${
                  data.pChange && data.pChange >= 0
                    ? "e-positive-color"
                    : "e-negative-color"
                }`}
              >
                <div
                  style={{
                    textAlign: "left",
                  }}
                >
                  <div>
                    {UnderlyingName} {data.strikePrice} {data.type}
                  </div>
                  <div
                    className="flexbox"
                    style={{
                      textAlign: "left",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <button
                      disabled={quantity[key] == null || quantity[key]! <= 1}
                      className={`e-small-button ${
                        quantity[key] == null ||
                        (quantity[key]! <= 1 && "disabled")
                      }`}
                      onClick={() => {
                        quantity[key] = quantity[key]! - 1;
                        setQuantity({
                          ...quantity,
                        });
                      }}
                    >
                      -
                    </button>
                    <span style={{ paddingRight: "8px", color: "black" }}>
                      <input
                        type="number"
                        value={
                          (quantity[key] == undefined
                            ? 1
                            : quantity[key]) as any
                        }
                        onChange={(e) => {
                          const value = parseInt(e.target.value);
                          quantity[key] = isNaN(value) ? "" : value;
                          setQuantity({ ...quantity });
                        }}
                        style={{
                          maxWidth: "50px",
                          fontSize: "0.95rem",
                          textAlign: "center",
                        }}
                      />
                    </span>
                    <button
                      className={`e-small-button`}
                      onClick={() => {
                        quantity[key] =
                          quantity[key] === undefined
                            ? 2
                            : quantity[key] !== ""
                            ? parseInt(quantity[key]!) + 1
                            : 1;
                        setQuantity({
                          ...quantity,
                        });
                      }}
                    >
                      +
                    </button>
                  </div>
                  <div style={{ textAlign: "left", marginTop: "8px" }}>
                    <button
                      onClick={() => addItem(data, key, true)}
                      className="e-buy-button"
                    >
                      Buy
                    </button>
                    <button
                      onClick={() => addItem(data, key, false)}
                      className="e-sell-button"
                    >
                      Sell
                    </button>
                  </div>
                  {positions[key] && (
                    <div style={{ color: "gray", paddingTop: "4px" }}>
                      Quantity: {positions[key].qty} @{" "}
                      {positions[key].price.toFixed(2)}
                    </div>
                  )}
                </div>
                <div className="e-price-column">
                  <div>LTP: {data.lastPrice}</div>
                  <div> {data.pChange?.toFixed(2)}%</div>
                  <div className="e-price-column">
                    <input
                      type="number"
                      placeholder="Price (optional)"
                      min={0}
                      style={{ width: "130px" }}
                      onChange={(e) => {
                        optionalPrice[key] = Number(e.target.value);
                        setOptionalPrice({ ...optionalPrice });
                      }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
    </div>
  );
};

export default WatchlistTab;
